module.exports = __webpack_public_path__ + "static/media/gui-testing.d729df57.svg";